import React, { FunctionComponent } from "react"
import reports from "../../utils/reports"
import HRRReportsTableBodyContextMenu from "./HRRReportsTableBodyContextMenu/HRRReportsTableBodyContextMenu"

const HRRReportsTableBody: FunctionComponent<{}> = () => {

    // const showOrHideContextMenu = (id: number, show: boolean) => {
    //     let elem: HTMLElement | any = document.getElementById(`e4f1a37f-9f83-4a88-aa22-e9f356524625-${id}`)
    //     if (elem) {
    //         elem.style.display = `${show ? "block" : "none"}`
    //     }
    // }

    return (
        <tbody>
            {reports.map((report, i) =>
                <tr
                    key={i}
                // onMouseEnter={() => showOrHideContextMenu(i, true)}
                // onMouseLeave={() => showOrHideContextMenu(i, false)}
                >
                    <td>
                        {report?.name}
                    </td>
                    <td>
                        <div className="HRReportTablePillContainer">
                            {report?.properties.items.map((item, j) =>
                                <div key={j} className="HRReportTablePill">
                                    {item.title}
                                </div>
                            )}
                        </div>
                    </td>
                    <td>
                        <div className="HRReportTableLastTR">
                            <div className="HRReportTablePillContainer">
                                {report?.properties.filterOn.map((filter, k) =>
                                    <div key={k} className="HRReportTablePill HRReportTablePillFilterPill">
                                        <div className="HRReportTablePillLeft">
                                            {filter.aliasValue ? `${filter.alias}:` : `${filter.alias}`}
                                        </div>
                                        {filter.aliasValue && <div className="HRReportTablePillRight">
                                            {filter.aliasValue}
                                        </div>}
                                    </div>
                                )}
                                {report?.properties.filterOn.length === 0 && <div className="HRReportTablePill HRReportTablePillFilterPill">
                                    <div className="HRReportTablePillLeft">
                                        none
                                    </div>
                                </div>}
                            </div>
                            <div className="HRRReportsTableBodyContextMenuContainer">
                                <HRRReportsTableBodyContextMenu
                                    id={`e4f1a37f-9f83-4a88-aa22-e9f356524625-${i}`}
                                    report={report}
                                />
                            </div>
                        </div>
                    </td>
                </tr>
            )}
        </tbody>
    )
}

export default HRRReportsTableBody